/**
 * Standard copy for destructive / remove actions so messaging stays consistent across the app.
 */
export const destructiveCopy = {
  cannotUndo: 'This action cannot be undone.',
  jobDeleteCascade:
    'Warning: The job, its invoice, and any related data may be permanently deleted.',
  removePayment:
    'This removes the payment from the job. Totals and payment status will be updated accordingly.',
  removeExpense: 'This removes the expense from the job.',
  removeLineItem: 'This removes the line item from the job or invoice.',
  removeEstimateContact:
    'This removes the contact from this estimate. The contact record is not deleted from your directory.',
  removeJobContact:
    'This removes the contact from this job only. The contact is not deleted from your directory.',
  deleteAttachment: 'Are you sure you want to delete this attachment?',
  deleteMessage: 'Delete this message? It may still appear as deleted for other participants.',
  logout: 'Are you sure you want to log out?',
  settledJobChange:
    "This job's balance has been settled. This change may affect the technician balance. " +
    'Do you want to keep it settled, or unsettle it so the new balance is treated as unpaid?',
} as const;
